var member_application_review = (function ($) {

    const _init = function () {
        _set_up_toggle();
        _set_up_accept_button();
    };

    const _set_up_toggle = function () {
        const $toggle_application_buttons = $('.application-toggle-button > a')

        if ($toggle_application_buttons.length > 0) {
            $toggle_application_buttons.on('click', _toggle_application);
        }
    };

    const _set_up_accept_button = function () {
        const $accept_buttons = $('.accept-certification-button');

        if ($accept_buttons.length > 0) {
            $accept_buttons.on('click', _on_accept_button_click);
        }
    };

    const _toggle_application = function (e) {
        e.preventDefault();

        const $this                = $(this);
        const $application_content = $this.closest('.application').find('.application-content');

        if ($application_content.length > 0) {
            $application_content.slideToggle();
            $this.toggleClass('open');
            $this.toggleClass('closed');

            _update_toggle_button_text($this);
        }
    };

    const _update_toggle_button_text = function ($button) {
        $button.blur();

        if ($button.hasClass('open')) {
            $button.text($button.data('open-text'));
        } else {
            $button.text($button.data('closed-text'));
        }
    }

    const _on_accept_button_click = function (e) {
        e.preventDefault();

        const $this = $(this);
        const $application = $this.closest('.application');
        const $checkbox = $application.find('.certification-checkbox');
        const userMembershipID = $application.data('user-membership');

        if (!userMembershipID) {
            return false;
        }

        if ($checkbox.length !== 1 || typeof $checkbox[0] === 'undefined' || !$checkbox[0].checked) {
            _display_application_notice(userMembershipID,'Please certify that the applicant is a bona fide applicant by checking the box above', true);
            return false;
        }

        _approve_application(userMembershipID);
    };

    const _approve_application = function (userMembershipID) {
        const data = {
            nonce: scriptData.vibe_eos_approveUserMembership_ajax_approve_nonce,
            action: 'vibe_eos_approveUserMembership_ajax_approve',
            userMembershipID: userMembershipID,
        }

        $.post(scriptData.ajaxURL, data, _approve_application_response)
    };

    const _approve_application_response = function (res) {
        if (res.userMembershipID) {
            _display_application_notice(res.userMembershipID, res.message, !res.success);

            if (res.success) {
                setTimeout(function ()  {
                    const $application = $(`.application[data-user-membership=${res.userMembershipID}]`);
                    const $applicationContent = $application.find('.application-content');
                    const $button = $application.find('.application-toggle-button > a').first();

                    $button.data('closed-text', $button.data('approved-text'));

                    $applicationContent.slideUp();
                    $button.addClass('closed');
                    $button.removeClass('open');
                    _update_toggle_button_text($button);
                    $application.find('.application-accept-section').addClass('hidden');
                }, 1500);
            }
        }
    };

    const _display_application_notice = function (userMembershipID, message, error = false) {
        const $application = $(`.application[data-user-membership='${userMembershipID}']`);
        const $notice = $application.find('.application-notice');

        $notice.slideUp(400, function() {
            if (error) {
                $notice.addClass('error');
            } else {
                $notice.removeClass('error');
            }

            $notice.text(message);
            $notice.slideDown();
        });
    };

    $(document).ready(_init);

    return {};

})(jQuery);

module.exports = member_application_review;